export function getCapacityColour(colourCode: string): string {
  switch (colourCode) {
    case "blue":       return "#06b6d4";
    case "cyan-green": return "#22d3a5";
    case "lime":       return "#84cc16";
    case "yellow":     return "#facc15";
    case "orange":     return "#f97316";
    case "red":        return "#ef4444";
    default:           return "#06b6d4";
  }
}

// Shared 5-tier capacity wording + word-driven colour scheme.
// Used by Home (Explore) and VenueDetailDrawer so the label, text colour,
// dot colour and chip border always agree across surfaces.
export function getCapacityLabel(level: number): string {
  if (level >= 85) return "Buzzin'";
  if (level >= 70) return "Busy";
  if (level >= 30) return "Steady";
  if (level > 0) return "Quiet";
  return "Empty";
}

export function getCapacityLabelTextClass(level: number): string {
  if (level >= 85) return "text-[hsl(var(--status-high))]";
  if (level >= 70) return "text-[hsl(var(--status-med))]";
  if (level >= 30) return "text-[hsl(var(--status-steady))]";
  if (level > 0) return "text-[hsl(var(--status-low))]";
  return "text-zinc-500";
}

export function getCapacityLabelDotClass(level: number): string {
  if (level >= 85) return "bg-[hsl(var(--status-high))]";
  if (level >= 70) return "bg-[hsl(var(--status-med))]";
  if (level >= 30) return "bg-[hsl(var(--status-steady))]";
  if (level > 0) return "bg-[hsl(var(--status-low))]";
  return "bg-zinc-500";
}

export type CapacityIconKind = "flame-pulse" | "flame" | "users" | "users-muted";

export function getCapacityIconKind(level: number): CapacityIconKind {
  if (level >= 85) return "flame-pulse";
  if (level >= 70) return "flame";
  if (level > 0) return "users";
  return "users-muted";
}

export function getCapacityChipClass(level: number): string {
  if (level >= 85) return "bg-[hsl(var(--status-high))]/10 border-[hsl(var(--status-high))]/40 text-[hsl(var(--status-high))]";
  if (level >= 70) return "bg-[hsl(var(--status-med))]/10 border-[hsl(var(--status-med))]/40 text-[hsl(var(--status-med))]";
  if (level >= 30) return "bg-[hsl(var(--status-steady))]/10 border-[hsl(var(--status-steady))]/40 text-[hsl(var(--status-steady))]";
  if (level > 0) return "bg-[hsl(var(--status-low))]/10 border-[hsl(var(--status-low))]/40 text-[hsl(var(--status-low))]";
  return "bg-zinc-700/20 border-zinc-700/40 text-zinc-400";
}
